import React from 'react';
import PropTypes from 'prop-types';
import { SixDotsScale } from 'react-svg-spinners';

import { gray900 } from 'components/new_ui/Colors';

export default function LoadingPlaceholder({
  text, color, placement, className,
}) {
  const placeholder = (
    <>
      <SixDotsScale color={color} />
      {text.length > 0 && (
        <span className="ms-2">{text}</span>
      )}
    </>
  );

  if (placement === 'center') {
    return (
      <div className={`text-center ${className}`}>
        {placeholder}
      </div>
    );
  }

  return placeholder;
}

LoadingPlaceholder.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  placement: PropTypes.string,
  className: PropTypes.string,
};

LoadingPlaceholder.defaultProps = {
  text: '',
  color: gray900,
  placement: 'center',
  className: '',
};
